var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.credits)?_c('li',{staticClass:"flix-html-li"},[_c('router-link',{staticClass:"flix-html-a",attrs:{"to":{name: 'dashboardCredits'}}},[_c('flix-icon',{attrs:{"id":'coins'}}),_vm._v(" "+_vm._s(_vm.credits.available)+" "+_vm._s(_vm.$t('message.credit'))+" ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }